import React from "react";

import PortaleChildApp from "../../portale-child-app";

const StudioHrView = () => <PortaleChildApp appId="HR" serviceId="PAYROLL" />;

export default StudioHrView;
